// extracted by mini-css-extract-plugin
export default {"members":"Team_members__AwQL2","member":"Team_member__5Z1R+","nickname":"Team_nickname__0x9tB","bio":"Team_bio__qGQDj"};